// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB_IcIZX-dyiM1d04YbeFVX2s9WY7BPBCk",
  authDomain: "varenya-matrimonial.firebaseapp.com",
  projectId: "varenya-matrimonial",
  storageBucket: "varenya-matrimonial.firebasestorage.app",
  appId: "1:406196822712:web:41c8cae4152f246bc78a4d",
  measurementId: "G-NR5WBBPYJ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
